// extracted by mini-css-extract-plugin
export default {"wrapper":"OPiejb3_dqP7HfjDC92n","textContent":"BuWXaoq_RkDKJl2QiA2m","inputContainer":"yheO0OWbKtZcw1yVn_lQ"};